import { Bot, TrendingUp, Briefcase, GraduationCap, Lock } from "lucide-react";

const clients = [
  { icon: TrendingUp, label: "Day Trader", y: 70 },
  { icon: Briefcase, label: "Investor", y: 185 },
  { icon: GraduationCap, label: "Beginner", y: 300 },
];

const brokers = [
  { icon: Lock, label: "Platform ●●●●", tag: "Low Fees", y: 70 },
  { icon: Lock, label: "Platform ●●●●", tag: "Pro Tools", y: 185 },
  { icon: Lock, label: "Platform ●●●●", tag: "Global Access", y: 300 },
];

const inPaths = clients.map((c) => `M 118 ${c.y} C 240 ${c.y}, 260 185, 350 185`);
const outPaths = brokers.map((b) => `M 450 185 C 540 185, 560 ${b.y}, 682 ${b.y}`);

const Dot = ({ path, dur, begin, color }) => (
  <circle r="5" fill={color}>
    <animateMotion dur={dur} begin={begin} repeatCount="indefinite" path={path} />
    <animate attributeName="opacity" values="0;1;1;0" keyTimes="0;0.1;0.9;1" dur={dur} begin={begin} repeatCount="indefinite" />
  </circle>
);

export const AnimatedBotWidget = () => (
  <div
    data-testid="animated-bot-widget"
    className="relative w-full bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden"
  >
    <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100">
      <span className="text-xs font-bold uppercase tracking-[0.2em] text-gray-500">
        AI Central — Smart Matching Engine
      </span>
      <span className="flex items-center gap-1.5 text-xs font-bold text-emerald-600">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
        </span>
        LIVE
      </span>
    </div>

    <div className="overflow-x-auto">
      <svg viewBox="0 0 800 370" className="w-full h-auto min-w-[560px]" role="img" aria-label="Animated diagram of AI Central routing traders and clients to their best-fit trading platforms">
      {inPaths.map((p, i) => (
        <path key={`ip${i}`} d={p} fill="none" stroke="#e4e4e7" strokeWidth="2" strokeDasharray="6 6" />
      ))}
      {outPaths.map((p, i) => (
        <path key={`op${i}`} d={p} fill="none" stroke="#e4e4e7" strokeWidth="2" strokeDasharray="6 6" />
      ))}

      {inPaths.map((p, i) => (
        <Dot key={`id${i}`} path={p} dur="2.4s" begin={`${i * 0.8}s`} color="#2563eb" />
      ))}
      {outPaths.map((p, i) => (
        <Dot key={`od${i}`} path={p} dur="2.4s" begin={`${i * 0.8 + 1.2}s`} color="#10b981" />
      ))}

      {/* client nodes */}
      {clients.map((c, i) => (
        <g key={`c${i}`}>
          <rect x="18" y={c.y - 26} width="100" height="52" rx="12" fill="#fff" stroke="#e4e4e7" strokeWidth="1.5" />
          <foreignObject x="18" y={c.y - 26} width="100" height="52">
            <div className="w-full h-full flex flex-col items-center justify-center gap-0.5">
              <c.icon className="w-4 h-4 text-blue-600" />
              <span className="text-[10px] font-bold text-gray-700">{c.label}</span>
            </div>
          </foreignObject>
        </g>
      ))}

      {/* broker nodes */}
      {brokers.map((b, i) => (
        <g key={`b${i}`}>
          <rect x="682" y={b.y - 30} width="104" height="60" rx="12" fill="#fff" stroke="#10b981" strokeWidth="1.5" />
          <foreignObject x="682" y={b.y - 30} width="104" height="60">
            <div className="w-full h-full flex flex-col items-center justify-center gap-0.5">
              <b.icon className="w-4 h-4 text-emerald-600" />
              <span className="text-[10px] font-bold text-gray-800">{b.label}</span>
              <span className="text-[8px] font-semibold text-emerald-600 bg-emerald-50 px-1.5 rounded-full">{b.tag}</span>
            </div>
          </foreignObject>
        </g>
      ))}

      {/* central AI bot */}
      <foreignObject x="330" y="115" width="140" height="140">
        <div className="w-full h-full flex items-center justify-center">
          <div className="relative w-24 h-24 flex items-center justify-center">
            <span className="absolute inset-0 rounded-full bg-blue-500/20" style={{ animation: "pulse-ring 2.4s ease-out infinite" }} />
            <span className="absolute inset-0 rounded-full bg-blue-500/10" style={{ animation: "pulse-ring 2.4s ease-out 1.2s infinite" }} />
            <div className="relative w-20 h-20 rounded-2xl bg-blue-600 shadow-lg shadow-blue-600/30 flex flex-col items-center justify-center gap-1">
              <Bot className="w-8 h-8 text-white" />
              <span className="text-[8px] font-bold text-blue-100 tracking-wide text-center leading-tight">AI CENTRAL<br />CORE</span>
            </div>
          </div>
        </div>
      </foreignObject>
    </svg>
    </div>

    <div className="px-5 py-3 border-t border-gray-100 bg-gray-50 text-center">
      <p className="text-xs text-gray-500 font-medium">
        Our AI analyzes your profile in real time and routes you to the trading platform that fits you best
      </p>
    </div>
  </div>
);
